"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicGrid = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const transformPropVal_1 = require("../../tools/transformPropVal");
const Grid_1 = require("../Grid");
function BasicGrid(_a) {
    var { numColumns, minChildWidth } = _a, props = __rest(_a, ["numColumns", "minChildWidth"]);
    const templateColumns = minChildWidth
        ? transformPropVal_1.transformPropVal(minChildWidth, value => `repeat(auto-fit, minmax(${typeof value === 'number' ? `${value}px` : value}, 1fr))`)
        : transformPropVal_1.transformPropVal(numColumns, cols => `repeat(${cols}, 1fr)`);
    return jsx_runtime_1.jsx(Grid_1.Grid, Object.assign({ templateColumns: templateColumns }, props), void 0);
}
exports.BasicGrid = BasicGrid;
//# sourceMappingURL=index.js.map